import React from 'react';
import { classes } from '../../../lib';
import Styles from './BlogPost.module.less';
import { SanityObject } from '../../../lib/landingPage';
import { Image, ImageProps } from '../../../bound/landingPage/Image';
import { Logotype } from '../../Logotype';

export type AuthorProps = {
    name: string;
    imageRef: SanityObject<ImageProps>;
    shortbio?: string;
};

export const BlogPostAuthor = ({
    author,
}: {
    author: SanityObject<AuthorProps>;
}) => {
    return (
        <div className={classes(Styles.author, 'vertical g16 p32')}>
            <div className={classes(Styles.authorTitle, 'horizontal g8')}>
                {author.imageRef ? (
                    <Image
                        className={Styles.authorLogo}
                        value={{
                            ...author.imageRef,
                            dataset: 'blog',
                        }}
                    />
                ) : (
                    <Logotype type="DefaultIcon" className={Styles.aludeLogo} />
                )}
                <div className={Styles.authorName}>
                    <span>O autor</span>
                    <h4>{author.name}</h4>
                </div>
            </div>
            <p>{author.shortbio}</p>
        </div>
    );
};
